import React, { useEffect, useReducer } from 'react';
import { useSelector } from 'react-redux';

import useSearch from '../../hooks/useSearch';
import { useTabs } from '../../hooks/useTabs';
import { useSaveSettings } from '../../hooks/useSaveSettings';
import { CATEGORIES, SUBCATEGORIES } from '../../common/categories';
import { fieldsReducer, initFieldsState, mapToSettings } from './silverfortApiReducer';

import { filterFieldsBySystemMode } from '../../common/utils';
import { USER_ENGAGEMENT_PAGE_KEYS } from '@silverfort-nodelibs/common/utils/consts';
import { httpPost } from '../../../utils';
import NewCategory from '../../components/Category/NewCategory';
import AuthTokensAndUsers from '../../components/AuthTokensAndUsers/AuthTokensAndUsers';
import AdfsAndMfa from '../../components/AuthTokensAndUsers/AdfsAndMfa';
import { useVisibleTabs } from '../../hooks/lockedFeatures/useVisibleTabs';

const { SILVERFORT_API } = CATEGORIES;
const { AUTH_TOKENS_AND_USERS, ADFS_AND_MFA } = SUBCATEGORIES;

const SilverfortApi = ({ saveFunc, systemMode }) => {
    const settings = useSelector((state) => state.settings.settings);

    const [fields, dispatch] = useReducer(fieldsReducer, { settings }, initFieldsState);
    const visibleFields = useSearch(useVisibleTabs(fields));
    const [selectedTab, setSelectedTab] = useTabs(SILVERFORT_API, visibleFields);
    const [save] = useSaveSettings(saveFunc, settings, mapToSettings, fields, selectedTab, dispatch);

    useEffect(() => {
        httpPost('/data/userEngagement', { pageId: USER_ENGAGEMENT_PAGE_KEYS.SETTINGS_API });
    }, []);

    return (
        <NewCategory
            category={SILVERFORT_API}
            fields={fields}
            visibleFields={visibleFields}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}>
            <RenderChild
                dispatch={dispatch}
                visibleFields={visibleFields}
                selectedTab={selectedTab}
                save={save}
                systemMode={systemMode}
            />
        </NewCategory>
    );
};

const RenderChild = ({ visibleFields, selectedTab, save, dispatch, systemMode }) => {
    if (visibleFields[AUTH_TOKENS_AND_USERS.ID] && selectedTab === AUTH_TOKENS_AND_USERS.ID) {
        return (
            <AuthTokensAndUsers
                fields={filterFieldsBySystemMode(visibleFields[AUTH_TOKENS_AND_USERS.ID].fields, systemMode)}
                save={save}
                dispatch={dispatch}
            />
        );
    }
    if (visibleFields[ADFS_AND_MFA.ID] && selectedTab === ADFS_AND_MFA.ID) {
        return (
            <AdfsAndMfa
                fields={filterFieldsBySystemMode(visibleFields[ADFS_AND_MFA.ID].fields, systemMode)}
                save={save}
                dispatch={dispatch}
            />
        );
    }

    return <></>;
};

export default SilverfortApi;
